import { type FC, useCallback, useRef } from 'react';
import { useSportSearchInput } from '@mwl/core-lib';
import { routes } from '@/constants';
import { useIsSportHistoryPage } from '@/hooks';
import { FilterAndSearch } from '../components/FilterAndSearch/FilterAndSearch';
import { MobileModeFilter } from '../components/MobileModeFilter/MobileModeFilter';
import { MobileSportFilter } from '../components/MobileSportFilter/MobileSportFilter';
import { SearchPopup } from '../components/SearchPopup/SearchPopup';
import type { MobileSportToolbarProps } from './MobileSportToolbar.types';
import styles from './MobileSportToolbar.module.scss';
export const MobileSportToolbar: FC<MobileSportToolbarProps> = ({
  sports,
  className,
  hideToolbarFilters,
  hideAdditionalToolbarFilters
}) => {
  const isSportHistoryPage = useIsSportHistoryPage();
  const searchRef = useRef<HTMLDivElement>(null);
  const {
    handleUpdateSearchView,
    ...params
  } = useSportSearchInput({
    elementRef: searchRef,
    routes
  });
  const handleClosePopup = useCallback(() => {
    params.handleClear();
    handleUpdateSearchView('default');
  }, [handleUpdateSearchView, params]);
  return <div className={cn(styles.root, {
    [styles.notSportHistory]: !isSportHistoryPage
  }, className)} data-sentry-component="MobileSportToolbar" data-sentry-source-file="MobileSportToolbar.tsx">
      <div className={styles.header}>
        <MobileModeFilter className={styles.modeFilter} data-sentry-element="MobileModeFilter" data-sentry-source-file="MobileSportToolbar.tsx" />

        {!hideToolbarFilters && <MobileSportFilter sports={sports} />}
      </div>
      {!hideToolbarFilters && !hideAdditionalToolbarFilters && <div className={cn(styles.footer, styles.additionalFiltersOpen)}>
          <div className={cn(styles.additionalFilters)}>
            <FilterAndSearch searchRef={searchRef} handleUpdateSearchView={handleUpdateSearchView} {...params} />
          </div>
        </div>}

      <SearchPopup searchRef={searchRef} handleClosePopup={handleClosePopup} handleUpdateSearchView={handleUpdateSearchView} {...params} data-sentry-element="SearchPopup" data-sentry-source-file="MobileSportToolbar.tsx" />
    </div>;
};